<template>
  <div class="pb100">
    <banner/>
    <crumbs/>
    <div class="container">
      <type-screen modelType="culture" :menu-id="this.$route.query.columnId" @typeObj="selectType"/>
      <ul class="ul-model6 clearfix mt20">
        <li @click.stop="detaillink(item.link)" v-for="(item, index) in List" :key="index">
          <a class="clearfix">
            <div class="imgbox">
              <img class="imgtop" :src="getImage(item.image)" alt="">
            </div>
            <div class="txtbox">
              <h2 class="textover">{{ item.title}}</h2>
            </div>
          </a>
        </li>
      </ul>
      <nodata v-show="nodataflag"/>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="Param.limit"
        :pager-count="5"
        :current-page.sync="currentPage"
        layout="prev, pager, next"
        :total="listTotal"
        class="pagemodel1">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import typeScreen from '@/components/typescreen/index'
import { getCultureList } from '@/api/culture/index'
import { scrollAnimation } from '@/utils/index'
import nodata from '@/components/nodata/index'
import { timeFormat } from '@/utils/validate'
export default {
  name: 'culture',
  meta: {
    showHeader: true
  },
  components: {
    typeScreen,
    crumbs,
    banner,
    nodata
  },
  data () {
    return {
      Param: {
        page: 1,
        limit: 12,
        menuId: this.$route.query.columnId,
        type: ''
      },
      currentPage: 1,
      nodataflag: false,
      List: [],
      listTotal: 0
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getTime (val) {
      return timeFormat(val, 'yymmddhhmm')
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    getList () {
      getCultureList(this.Param).then(res => {
        if (res.data.status === 200) {
          this.listTotal = res.data.data.total
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          this.List = res.data.data.rows
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    /* 筛选条件 */
    selectType (obj) {
      this.Param.type = obj.type
      this.Param.page = 1
      this.currentPage = 1
      this.getList()
    },
    // 分页触发
    handleCurrentChange (val) {
      this.Param.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getList()
    },
    detaillink (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/culture/list.vue